import { useCallback, useContext } from "react"
import { Button, ParagraphMedium } from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import { resetDepositState, useDappDispatch } from "#/redux-state"
import { routes } from "#/shared/constants"
import { FlowContext } from "#/shared/context"

type DepositCompletedScoreProps = {
  onClick: () => void
}

export default function DepositCompletedScore({
  onClick,
}: DepositCompletedScoreProps) {
  const { flow } = useContext(FlowContext)

  const dispatch = useDappDispatch()

  const navigationHandler = useCallback(() => {
    dispatch(resetDepositState({ flow }))
    onClick()
  }, [flow, dispatch, onClick])

  return (
    <>
      <ParagraphMedium marginBottom="scale800">
        Your deposit is on its way. <br />
        While we are processing that, why not discover ways to grow your HODL
        score.
      </ParagraphMedium>
      <Button
        $as={Link}
        href={`${routes.DEPOSIT}?tab=manage`}
        onClick={navigationHandler}
        shape="pill"
        size="large"
      >
        My deposits
      </Button>
    </>
  )
}
